// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "wrapper-2SyeM";
var _4 = "left-3uM8F";
var _5 = "right-2ByHV";
var _6 = "title-2f4op";
export { _1 as "__esModule", _2 as "mobile", _3 as "wrapper", _4 as "left", _5 as "right", _6 as "title" }
export default { "__esModule": _1, "mobile": _2, "wrapper": _3, "left": _4, "right": _5, "title": _6 }
